import React from 'react';
import './partners.css';
import { Link } from 'react-router-dom';
import prodictpagelogo from "../assets/images/prodictpagelogo.svg";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from "../LanguageSwitcher";

// Importing partner logos
import Bucher from "../assets/images/Bucher.svg";
import ce from "../assets/images/ce.svg";
import Ice from "../assets/images/Ice.svg";
import Infaco from "../assets/images/Infaco.svg";
import Des from "../assets/images/Des.svg";
import Rodina from "../assets/images/Rodina.svg";
import Siprem from "../assets/images/Siprem.svg";
import Carmo from "../assets/images/Carmo.svg";
import TECNOVAP from "../assets/images/TECNOVAP.svg";
import SORDATO from "../assets/images/sordato.svg";
import Francesa from "../assets/images/Francesa.svg";
import CANDELLI from "../assets/images/CANDELLI.svg";
import Ghidinie from "../assets/images/Ghidinie.svg";
import Enomatic from "../assets/images/Enomatic.svg";
import DrunkTurtle from "../assets/images/DrunkTurtle.svg";
import Construzioni from "../assets/images/Construzioni.svg";
import Castellari from "../assets/images/Castellari.svg";
import DAINESE from "../assets/images/DAINESE.svg";
import BORELLI from "../assets/images/BORELLI.svg";
import ANASelection from "../assets/images/ANASelection.svg";
import AMORIM from "../assets/images/AMORIM.svg";

const partners = [
  { name: "Bucher",  logo: Bucher },
  { name: "CE",  logo: ce },
  { name: "Ice", logo: Ice },
  { name: "Infaco",logo: Infaco },
  { name: "Des", logo: Des },
  { name: "Rodina",  logo: Rodina },
  { name: "Siprem", logo: Siprem },
  { name: "Carmo",  logo: Carmo },
  { name: "TECNOVAP", logo: TECNOVAP },
  { name: "SORDATO",  logo: SORDATO },
  { name: "Francesa", logo: Francesa },
  { name: "CANDELLI",  logo: CANDELLI },
  { name: "Ghidinie",  logo: Ghidinie },
  { name: "Enomatic",  logo: Enomatic },
  { name: "Drunk Turtle",  logo: DrunkTurtle },
  { name: "Construzioni",  logo: Construzioni },
  { name: "Castellari",  logo: Castellari },
  { name: "DAINESE", logo: DAINESE },
  { name: "BORELLI", logo: BORELLI },
  { name: "ANA Selection",  logo: ANASelection },
  { name: "AMORIM",logo: AMORIM },
];

const Partners = () => {
  const { t } = useTranslation();

  return (

    <div className="partners-container">
      <LanguageSwitcher id="sidebar" />
      <div className="Partners-Logo-home">
        <Link to="/" className="logolink">
          <img src={prodictpagelogo} alt="Product Page Logo" />
        </Link>
      </div>

      <header className="partners-header">
        <h1>{t("Ce Enologica")}</h1>
        <p>{t("Partners")}</p>
      </header>
        <div className='partnersline'>
        </div>
      <div className="partners-grid">
        {partners.map((partner, index) => (
          <div key={index} className="partner-item">
            <img src={partner.logo} alt={`${partner.name} Logo`} className="partner-logo" />
            <div className="partner-info">
              <h3>{partner.name}</h3>
              <p>{t(partner.description)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partners;
